// Ring sizes as people write them, the server's photoPipeline/ringSize.js
// rules: the server stores a decimal (6.75) and the clerk sees and types
// fractions ("6¾", "6 3/4"). Sizes come in quarters (Daniel, 2026-10-30), and
// the server refuses anything else on save.

const FRACTION_CHARS = { 0.25: '¼', 0.5: '½', 0.75: '¾' }
const CHAR_VALUES = { '¼': 0.25, '½': 0.5, '¾': 0.75 }
const TYPED_FRACTIONS = { '1/4': 0.25, '2/4': 0.5, '1/2': 0.5, '3/4': 0.75 }

export function isQuarterSize(size) {
    return Number.isFinite(size) && Number.isInteger(size * 4)
}

// 6.25 or "6.25" -> "6¼"; a non-quarter legacy size prints as its decimal; nothing -> "".
export function formatRingSize(value) {
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) return ''
    const size = Number(value)
    if (!Number.isFinite(size)) return ''
    if (!isQuarterSize(size)) return String(size)

    const whole = Math.floor(size)
    const fraction = size - whole
    return fraction === 0 ? String(whole) : `${whole || ''}${FRACTION_CHARS[fraction]}`
}

// "6¼", "6 1/4", "6-1/4", "6.25" or 6.25 -> 6.25; anything unreadable -> null.
export function parseRingSize(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null
    if (typeof value !== 'string') return null
    const text = value.trim()

    if (/^\d+(\.\d+)?$/.test(text)) return Number(text)

    const withChar = text.match(/^(\d+)?\s*([¼½¾])$/)
    if (withChar) return Number(withChar[1] ?? 0) + CHAR_VALUES[withChar[2]]

    const typed = text.match(/^(\d+)(?:\s+|-)(\d+\/\d+)$/)
    if (typed && Object.hasOwn(TYPED_FRACTIONS, typed[2])) return Number(typed[1]) + TYPED_FRACTIONS[typed[2]]

    return null
}
